import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';

interface Props {
  onFiles: (files: FileList | File[]) => void;
}

/** Drag-drop + click-to-browse drop zone for PDF uploads. */
export const DropZone: React.FC<Props> = ({ onFiles }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          if (e.dataTransfer.files?.length) onFiles(e.dataTransfer.files);
        }}
        className={`
          mb-3 w-full rounded-2xl border-2 border-dashed bg-white px-4 py-7 text-center transition
          ${over
            ? 'border-[#0e9172] bg-[#0e9172]/5 -translate-y-0.5'
            : 'border-slate-300 hover:border-[#0e9172] hover:bg-[#0e9172]/5'}
        `}
      >
        <span className="mx-auto mb-2.5 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1a5276] to-[#0e9172] text-white">
          <Upload size={22} />
        </span>
        <p
          className="m-0 mb-1 text-[18px] text-slate-900"
          style={{ fontFamily: "'Instrument Serif', serif" }}
        >
          Drag PDFs here, or tap to browse
        </p>
        <p className="m-0 text-[11.5px] text-slate-500">
          PDF only · 30 MB max per file · multiple files supported
        </p>
      </button>

      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,.pdf"
        multiple
        className="hidden"
        onChange={(e) => e.target.files && onFiles(e.target.files)}
      />
    </>
  );
};
